import * as React from "react";
import { useTheme } from "@mui/material";
const InlineCode = ({ children, className, }) => {
    const theme = useTheme();
    return (React.createElement("span", { className: className, style: {
            backgroundColor: theme.palette.grey[300],
            color: theme.palette.getContrastText(theme.palette.grey[300]),
            padding: theme.spacing(0.25, 0.5),
            borderRadius: theme.spacing(0.25),
            fontFamily: "'Source Code Pro', monospace",
        } }, children));
};
export default InlineCode;
